import { createElement } from 'react';
import cn from 'clsx';
import { cva, type VariantProps } from 'class-variance-authority';

import styles from './Headline.module.css';

const headlineVariants = cva(styles.baseClass, {
  variants: {
    size: {
      h1: styles.h1,
      h2: styles.h2,
      h3: styles.h3,
      h4: styles.h4,
      h5: styles.h5,
      h6: styles.h6,
    },
  },
  defaultVariants: {
    size: 'h2',
  },
});

export type HeadlineTagName = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'div' | 'span' | 'summary' | 'legend' | 'q';

export type HeadlineProps = {
  className?: string;
  as?: HeadlineTagName;
  label: string;
  'data-testid'?: string;
} & VariantProps<typeof headlineVariants>;

export const Headline = ({ className, size, as = 'h2', label, ...props }: HeadlineProps) => {
  return createElement(as, { className: cn(headlineVariants({ size }), className), ...props }, label);
};
